import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, MessageCircle } from "lucide-react";
import logoWhite from "../assets/logo-white.png";
import { useLang } from "../i18n/LanguageContext";
import { CONTACT, ACTIVITIES } from "../data/mock";

const Footer = () => {
  const { t, lang } = useLang();
  const year = new Date().getFullYear();
  const featured = ACTIVITIES.slice(0, 6);

  return (
    <footer className="bg-[#1c221e] text-[#d8dcd2]">
      <div className="max-w-7xl mx-auto px-5 md:px-8 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          <div className="md:col-span-1">
            <img src={logoWhite} alt="AGADIR VIBES" className="h-16 w-auto object-contain mb-5" />
            <p className="text-sm leading-relaxed text-[#a7ac9f] max-w-xs">{t.footer.tagline}</p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#7c8f74] mb-5 font-semibold">
              {t.footer.explore}
            </h4>
            <ul className="space-y-2.5">
              {featured.map((a) => (
                <li key={a.id}>
                  <Link
                    to={`/activites/${a.slug}`}
                    className="text-sm text-[#c3c8bb] hover:text-white transition-colors"
                  >
                    {a.title[lang]}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#7c8f74] mb-5 font-semibold">
              {t.footer.contactTitle}
            </h4>
            <ul className="space-y-3.5 text-sm">
              <li>
                <a href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-3 hover:text-white transition-colors">
                  <Phone size={16} className="text-[#7c8f74]" /> {CONTACT.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 hover:text-white transition-colors">
                  <Mail size={16} className="text-[#7c8f74]" /> {CONTACT.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin size={16} className="text-[#7c8f74]" /> {CONTACT.city[lang]}
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#7c8f74] mb-5 font-semibold">
              {t.footer.follow}
            </h4>
            <div className="flex items-center gap-3">
              <a
                href={CONTACT.instagram}
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                data-testid="footer-instagram-link"
                className="w-10 h-10 rounded-full border border-[#3a423a] flex items-center justify-center hover:bg-[#7c8f74] hover:border-[#7c8f74] transition-all"
              >
                <Instagram size={18} />
              </a>
              <a
                href={CONTACT.tiktok}
                target="_blank"
                rel="noreferrer"
                aria-label="TikTok"
                data-testid="footer-tiktok-link"
                className="w-10 h-10 rounded-full border border-[#3a423a] flex items-center justify-center hover:bg-[#7c8f74] hover:border-[#7c8f74] transition-all"
              >
                <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M16.6 5.82a4.28 4.28 0 0 1-1.04-2.82h-3.1v12.4a2.52 2.52 0 1 1-2.52-2.52c.26 0 .52.04.76.12V9.8a5.66 5.66 0 0 0-.76-.06 5.62 5.62 0 1 0 5.62 5.62V9.01a7.35 7.35 0 0 0 4.34 1.4V7.3a4.29 4.29 0 0 1-3.3-1.48Z"/>
                </svg>
              </a>
              <a
                href={`https://wa.me/${CONTACT.whatsapp}`}
                target="_blank"
                rel="noreferrer"
                aria-label="WhatsApp"
                data-testid="footer-whatsapp-link"
                className="w-10 h-10 rounded-full border border-[#3a423a] flex items-center justify-center hover:bg-[#7c8f74] hover:border-[#7c8f74] transition-all"
              >
                <MessageCircle size={18} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-[#2e352f] flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-[#8b9083] tracking-wide">
            © {year} AGADIR VIBES. {t.footer.rights}
          </p>
          <p className="text-xs text-[#8b9083] tracking-wide">Agadir · Maroc</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
